import script from "./ActivityTmplItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActivityTmplItems.vue?vue&type=script&lang=ts&setup=true"

import "./ActivityTmplItems.vue?vue&type=style&index=0&id=019193a8&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019193a8"]])

export default __exports__